import { UnitTypes } from 'unitData/types';

export const getVariant = (unitType: UnitTypes, variantId?: number) => {
  if (variantId) {
    return variantId;
  }

  switch (unitType) {
    case UnitTypes.STORAGE:
      return 1;
    case UnitTypes.STORAGE_FEEDER:
      return 3;
    case UnitTypes.STORAGE_FEEDER_2_OUTPUTS:
      return 2;
    default:
      return undefined;
  }
};
